import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import {
  TabList,
  TabbedView,
  Tab,
  TabPanel,
} from 'components/shared/TabbedView';
import Pagination from 'components/shared/pagination';
import {
  requestUpcomingEvents,
  requestPastEvents,
  requestUpcomingOpenEvents,
  tabSelect,
} from 'actions/inPersonTraining/eventsDashboardTabs/tab';
import { Spinner } from 'ui';
import Event from '../Event';

const Events = ({ events }) => (
  <div className="Animated Animated--fadeIn">
    {events.map(event => (
      <Event
        key={event.session.id}
        event={event.event}
        session={event.session}
        siblingSessions={event.siblingSessions}
        attendances={event.attendances}
        urls={event.urls}
      />
    ))}
  </div>
);

const LoadablePanelData = ({ children, loading }) => (
  <>
    {loading && (
      <div className="EventDashboard-loading">
        <Spinner className="mr-16" />
        <span>{t('common.loading')}</span>
      </div>
    )}
    {!loading && children}
  </>
);

const EventsDashboardEventList = ({
  pastEvents,
  upcomingEvents,
  upcomingOpenEvents,
  dispatchRequestUpcomingEvents,
  dispatchRequestPastEvents,
  dispatchRequestUpcomingOpenEvents,
  dispatchTabSelect,
  selectedTabIndex,
}) => {
  const hasPastEvents = !isEmpty(pastEvents.collection);
  const hasUpcomingEvents = !isEmpty(upcomingEvents.collection);
  const hasUpcomingOpenEvents = !isEmpty(upcomingOpenEvents.collection);
  return (
    <div className="EventsDashboardEventList">
      <TabbedView
        onSelect={index => dispatchTabSelect(index)}
        selectedIndex={selectedTabIndex}
      >
        <TabList className="mb-24">
          {hasUpcomingEvents && (
            <Tab>
              {t('in_person_training.events_dashboard.upcoming_events')}
            </Tab>
          )}
          {hasPastEvents && (
            <Tab>{t('in_person_training.events_dashboard.past_events')}</Tab>
          )}
          {hasUpcomingOpenEvents && (
            <Tab>{t('in_person_training.events_dashboard.open_events')}</Tab>
          )}
        </TabList>
        {hasUpcomingEvents && (
          <TabPanel>
            <LoadablePanelData loading={upcomingEvents.loading}>
              <Events events={upcomingEvents.collection} />
              <Pagination
                pages={upcomingEvents.pageCount}
                pageSelectCallback={page => dispatchRequestUpcomingEvents(page)}
                selected={upcomingEvents.page}
                className="mb-40"
              />
            </LoadablePanelData>
          </TabPanel>
        )}
        {hasPastEvents && (
          <TabPanel>
            <LoadablePanelData loading={pastEvents.loading}>
              <Events events={pastEvents.collection} />
              <Pagination
                pages={pastEvents.pageCount}
                pageSelectCallback={page => dispatchRequestPastEvents(page)}
                selected={pastEvents.page}
                className="mb-40"
              />
            </LoadablePanelData>
          </TabPanel>
        )}
        {hasUpcomingOpenEvents && (
          <TabPanel>
            <LoadablePanelData loading={upcomingOpenEvents.loading}>
              <Events events={upcomingOpenEvents.collection} />
              <Pagination
                pages={upcomingOpenEvents.pageCount}
                pageSelectCallback={page =>
                  dispatchRequestUpcomingOpenEvents(page)
                }
                selected={upcomingOpenEvents.page}
                className="mb-40"
              />
            </LoadablePanelData>
          </TabPanel>
        )}
      </TabbedView>
    </div>
  );
};

const mapStateToProps = state => ({
  upcomingEvents: state.events.upcomingEvents,
  pastEvents: state.events.pastEvents,
  upcomingOpenEvents: state.events.upcomingOpenEvents,
  selectedTabIndex: state.events.tabIndex,
});

const mapDispatchToProps = {
  dispatchRequestUpcomingEvents: requestUpcomingEvents,
  dispatchRequestPastEvents: requestPastEvents,
  dispatchRequestUpcomingOpenEvents: requestUpcomingOpenEvents,
  dispatchTabSelect: tabSelect,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventsDashboardEventList);
